import { Box, Button, Gap, Heading, P } from '@salecycle/ui-component-library';
import copy from 'copy-to-clipboard';
import useNotifications from 'core/notifications/useNotifications';
import { useTranslation } from 'react-i18next';
import { useTemplateEditorState } from '../../../../context/UseTemplateEditorContext';
import { LinksPreviewContainer } from '../../../style';

export const TemplateLinksView = () => {
  const { t } = useTranslation('trackingLinks');
  const { showNotification } = useNotifications();
  const { precompiledLinks, transformedLinks } = useTemplateEditorState();

  const extractedTransformedLinks = transformedLinks.map(x => {
    if (Object.keys(x).length < 1) {
      return {};
    }

    return {
      id: Object.keys(x)[0],
      href: Object.values(x)[0],
    };
  });

  const links = precompiledLinks.map(link => {
    const match = extractedTransformedLinks.find(x => x.id === link.id);
    link.transformedHref = match?.href;

    return link;
  });

  function getTrackingOutputText() {
    const strings = [];
    if (links.length > 0) {
      links.map(link => {
        return strings.push(
          String(
            `${t('trackingLinks:templateLevel.rightPanel.before')} ${link.href} ${t(
              'trackingLinks:templateLevel.rightPanel.after',
            )} ${link.transformedHref}`,
          ),
        );
      });
    }
    return strings.join('\r\n');
  }

  return (
    <LinksPreviewContainer data-testid="LinksView">
      {links.length > 0 ? (
        <div>
          <Button
            variation="secondary"
            onClick={() => {
              copy(getTrackingOutputText());
              showNotification(t('trackingLinks:templateLevel.rightPanel.trackingOutputCopied'), 'normal');
            }}
          >
            {t('trackingLinks:templateLevel.rightPanel.copyTrackingOutput')}
          </Button>
          <Gap bottom={40} />
          {/* Displaying the links from the template */}
          {links.map(link => {
            return (
              <div key={link.id}>
                <Heading variation="h4">{t('trackingLinks:templateLevel.rightPanel.before')}</Heading>
                <P>{link.href}</P>
                <Gap bottom={20} />
                <Heading variation="h4">{t('trackingLinks:templateLevel.rightPanel.after')}</Heading>
                <P>{link.transformedHref}</P>
                <Gap bottom={60} />
              </div>
            );
          })}
        </div>
      ) : (
        <Box stackItems={true} verticalPositioning="center" horizontalPositioning="center">
          <Heading variation="h4">{t('trackingLinks:templateLevel.rightPanel.noLinksHeading')}</Heading>
        </Box>
      )}
    </LinksPreviewContainer>
  );
};
